import { useBookServiceContext } from "../../Contexts/BookServiceContext";
import TalktodoctorIcon from "../../assets/talktodoctor.png";
import video_consult from "../../assets/video_consult.png";
import ConsultIcon from "../../assets/consult.png";
import Button from "../../Components/Button";
import TestIcon from "../../assets/test.png";
import { useAuth } from "../../Contexts/AuthContext";

export default function BookService() {

  const { navigate } = useBookServiceContext();
  const { memberStatus } = useAuth();

  const handleGotoVideoConsult=()=>{
    window.open("https://teleconsult.maxicare.com.ph/member-validation","_blank","noopener");
  }

  return (
    <div className="flex flex-col items-center min-h-screen max-w-screen sm:bg-[#E7EEFA] ">
      <div className="bg-white w-screen mb-[56px] sm:mb-24 lg:mb-12 sm:mt-12 sm:w-148 h-auto rounded-xl">
        <div className="p-3 my-2 text-center border-b">
          <p className="text-md font-bold">Book a service</p>
        </div>
        <div className="py-4 px-6">
          <p className="font-bold text-lg">Primary Care Clinic appointment</p>
          <p className="text-gray-500">
            Schedule a consultation or procedure at a Maxicare clinic near you
          </p>

          <Button
            disabled={!memberStatus.isMember}
            className={`w-full h-full bg-transparent border rounded-lg flex items-center p-3 my-3 transition ease-linear cursor-pointer ${
              !memberStatus.isMember
                ? "opacity-50"
                : "hover:scale-105"
            }`}
            onClick={() => navigate("/consult-doctor/choose-policy")}
          >
            <img
              src={ConsultIcon}
              alt="Consult a doctor"
              className="w-16 h-16 m-2"
            />
            <div className="ml-2 text-left">
              <p className="font-semibold text-lg">Consult a doctor</p>
              <p className="text-gray-500">Meet in person with a doctor</p>
            </div>
          </Button>

          <Button
            disabled={!memberStatus.isMember}
            className={`w-full h-full bg-transparent border rounded-lg flex items-center p-3 my-3 transition ease-linear cursor-pointer ${
              !memberStatus.isMember
                ? "opacity-50"
                : "hover:scale-105"
            }`}
            onClick={() => navigate("/request-medical-test/policy")}
          >
            <img
              src={TestIcon}
              alt="Request medical test"
              className="w-16 h-16 m-2"
            />
            <div className="ml-2 text-left">
              <p className="font-semibold text-lg">Request medical tests</p>
              <p className="text-gray-500">Get medical tests done</p>
            </div>
          </Button>

          <p className="font-bold text-lg">Teleconsult - Video and Voice</p>
          <p className="text-gray-500">Connect with a doctor from anywhere.</p>

          <button
            onClick={handleGotoVideoConsult}
            disabled={!memberStatus.isMember}
            className={`w-full h-full bg-transparent border rounded-lg flex items-center p-3 my-3 transition ease-linear ${!memberStatus.isMember ? "opacity-50" : "hover:scale-105"}`}
          >
            <div className="flex items-center">
              <img
                src={video_consult}
                alt="video consult icon"
                className="w-16 m-2"
              />
              <div className="ml-2 text-left">
                <p className="font-semibold text-lg">Video Consult</p>
                <p className="text-gray-500">
                  If you’re feeling unwell, you can see a doctor from anywhere.
                </p>
              </div>
            </div>
          </button>

          <Button
            disabled={!memberStatus.isMember}
            className={`w-full h-full bg-transparent border rounded-lg flex items-center p-3 my-3 transition ease-linear cursor-pointer ${
              !memberStatus.isMember
                ? "opacity-50"
                : "hover:scale-105"
            }`}
            onClick={() => navigate("/teleconsult-voice/instructions")}
          >
            <img
              src={TalktodoctorIcon}
              alt="talk to a doctor icon"
              className="w-16 m-2"
            />
            <div className="ml-2 text-left">
              <p className="font-semibold text-lg">Talk to a doctor</p>
              <p className="text-gray-500">
                Effortlessly consult with a doctor over the phone
              </p>
            </div>
          </Button>

          {/* <p className="font-bold text-lg">Homecare</p>
          <p className="text-gray-500">
            Get your consultation and laboratory tests done in the safety of
            your home or office
          </p>

          <Button
            disabled={!memberStatus.isMember}
            className={`w-full h-full bg-transparent border rounded-lg flex items-center p-3 my-3 transition ease-linear cursor-pointer ${
              !memberStatus.isMember
                ? "opacity-50"
                : "hover:scale-105"
            }`}
            onClick={() => navigate("/book-service/home")}
          >
            <img
              src={TestIcon}
              alt="Request medical test"
              className="w-16 h-16 m-2"
            />
            <div className="ml-2 text-left">
              <p className="font-semibold text-lg">Book home service</p>
              <p className="text-gray-500">
                Services available: Rabies vaccine, and laboratory test for
                blood, urine, stool
              </p>
            </div>
          </Button> */}
        </div>
      </div>
    </div>
  );
}
